import { render, staticRenderFns } from "./competeProductPrice.vue?vue&type=template&id=05d619d8&scoped=true"
import script from "./competeProductPrice.vue?vue&type=script&lang=js"
export * from "./competeProductPrice.vue?vue&type=script&lang=js"
import style0 from "./competeProductPrice.vue?vue&type=style&index=0&id=05d619d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d619d8",
  null
  
)

export default component.exports